import { usePersistMagicTableQueryParams } from '@sequencehq/core-components'
import { ProtectedRoute } from 'lib/rbac'
import { RouteObject, useNavigate, useParams } from 'react-router-dom'

const basePath = 'usage-metrics'

export const usageMetricsRoutes = (): RouteObject[] => [
  {
    path: `/${basePath}`,
    lazy: async () => {
      const { UsageMetrics } = await import('./pages/listView/UsageMetrics')
      return {
        Component: () => (
          <ProtectedRoute permission="org.usage:read">
            <UsageMetrics />
          </ProtectedRoute>
        )
      }
    },
    children: [
      {
        path: ':metricId',
        lazy: async () => {
          const { ViewUsageMetric } = await import(
            './components/modals/viewUsageMetric/ViewUsageMetric'
          )
          return {
            Component: () => (
              <ProtectedRoute permission="org.usage:read">
                <ViewUsageMetric />
              </ProtectedRoute>
            )
          }
        }
      },
      {
        path: ':metricId/edit',
        lazy: async () => {
          const { EditUsageMetricDrawer } = await import(
            './components/modals/EditUsageMetricDrawer'
          )
          const EditUsageMetricRoute = () => {
            const { metricId } = useParams<{ metricId: string }>()
            const navigate = useNavigate()
            const { persistMagicTableQueryParams } =
              usePersistMagicTableQueryParams()

            if (!metricId) {
              navigate(persistMagicTableQueryParams(usageMetricsPaths.list()))
              return null
            }

            return (
              <EditUsageMetricDrawer
                usageMetricId={metricId!}
                onClose={() => {
                  navigate(
                    persistMagicTableQueryParams(usageMetricsPaths.list())
                  )
                }}
                onUpdate={() => {
                  navigate(
                    persistMagicTableQueryParams(
                      usageMetricsPaths.view(metricId)
                    )
                  )
                }}
                closeOnUpdate={false}
              />
            )
          }
          return {
            Component: () => (
              <ProtectedRoute permission="org.usage:update">
                <EditUsageMetricRoute />
              </ProtectedRoute>
            )
          }
        }
      }
    ]
  }
]

export const usageMetricsPaths = {
  list: () => `/${basePath}`,
  view: (metricId: string) => `/${basePath}/${metricId}`,
  edit: (metricId: string) => `/${basePath}/${metricId}/edit`
}
